import React from 'react';
import { ExpandMore } from '@material-ui/icons';
import { makeStyles } from '@material-ui/core/styles';
import { AutocompleteArrayInput, BooleanInput, SimpleFormIterator, ArrayInput, SelectInput, ReferenceInput,
  SelectArrayInput,TextInput, ReferenceArrayInput} from 'react-admin';
import { Accordion, AccordionSummary, AccordionDetails, Box } from '@material-ui/core';
import FilterCardTitle from './FilterCardTitle';

const useStyles = makeStyles({
  filter: {
    backgroundColor: '#3e3e3e',
    marginBottom: '20px'
  }
});

const handleClickExclude = function (source) {
	alert("You are changing the Exclude flag. Make sure that this is what you intend to do.");
}

const validateListSize = (values) => validMaxLineSeparated(values, 5000);

const osChoices = [
  {name: 'Windows', id: 'windows' },
  {name: 'Mac OS', id: 'mac' },
  {name: 'Android', id: 'android' },
  {name: 'iOS', id: 'ios' },
  {name: 'Chrome OS', id: 'chrome' },
  {name: 'WebOS', id: 'webOS' },
  {name: 'Palm', id: 'plam' },
  {name: 'MeeGo', id: 'meego' },
  {name: 'Maemo', id: 'maemo' },
  {name: 'Tizen', id: 'tizen' },
  {name: 'Linux', id: 'linux' },
  {name: 'Symbian', id: 'symbian' },
  {name: 'Roku', id: 'roku' }
];

const matchTypeChoices = [
	{ id: 'contains', name: 'Contains' },
	{ id: 'startsWith', name: 'Starts With' },
	{ id: 'endsWith', name: 'Ends With' },
	{ id: 'equalsIgnoreCase', name: 'Equals Ignore Case' },
	{ id: 'exact', name: 'Exact Match' },
	{ id: 'equals', name: 'Equals' }
];

const deviceTypeChoices = [
	{ id: 'Computer', name: 'Desktop' },
	{ id: 'Mobile', name: 'Mobile' },
	{ id: 'Tablet', name: 'Tablet' },
	{ id: 'Game Console', name: 'Game console' },
	{ id: 'Digital Media Receiver', name: 'Digital Media Receiver (CTV/OTT)' },
	{ id: 'Unknown', name: 'Unknown' }
];

export const regionChoices = [
	{ id: 'us-east-1', name: 'AWS - us-east-1 (NV)' },
  { id: 'us-east-2', name: 'AWS - us-east-2 (OH)' },
	{ id: 'us-west-2', name: 'AWS - us-west-2 (OR)' },
	{ id: 'eu-west-1', name: 'AWS - eu-west-1 (Ireland)' },
  { id: 'nyc3', name: 'DO - nyc3 (NY)' },
  { id: 'nyc1', name: 'DO - nyc1 (NY)' },
  { id: 'tor1', name: 'DO - tor1 (Toronto)' },
  { id: 'sfo3', name: 'DO - sfo3 (SF)' },
  { id: 'ams3', name: 'DO - ams3 (Amsterdam )' },
];

const viewabilityChoices = [
  { id: '1', name: 'Between 1 and 10' },
  { id: '10', name: 'Between 10 and 20' },
  { id: '20', name: 'Between 20 and 30' },
  { id: '30', name: 'Between 30 and 40' },
  { id: '40', name: 'Between 40 and 50' },
  { id: '50', name: 'Between 50 and 60' },
  { id: '60', name: 'Between 60 and 70' },
  { id: '70', name: 'Between 70 and 80' },
  { id: '80', name: 'Between 80 and 90' },
  { id: '90', name: 'Between 90 and 100'}
];

const countryChoices = require('../../components/countries.json');
const mediaCategories = require('../../components/media_categories.json');
const { validMaxLineSeparated } = require('../../components/validation.js');

const siteFormat = (permissions, e) => {
  if (permissions && permissions.role && e) {
    return isAdmin(permissions) ? `${e.name} - ${e.adunit_path} - ${e.code}` : `${e.name} - ${e.code}`;
  }
};

const isAdmin = (permissions) => permissions.role === 'admin';

const segmentValues = (record, segment_filter) => {
  if (record && record.segment && record.segment[segment_filter]) { 
    return record.segment[segment_filter].values
  } else {
     return null 
  };
}

const showExcludeInput = function (permissions, props) {
  const hide = props && props.hideExclude;
  return isAdmin(permissions) && !hide ? {display: 'block'} : {display: 'none'}
} 

export function PublisherFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
   <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Publishers" values={segmentValues(record, 'filter_publisher')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_publisher.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)} />
          <ReferenceArrayInput source="segment.filter_publisher.values" label="Publisher"
            filter={props.filter ? props.filter : null}
            reference="publishers"
            basePath='publishers'
            perPage={20}
            sort={{ field: 'name', order: 'ASC' }}
            filterToQuery={searchText => ({ search_name: searchText })}
            emptyText="- None -">
            <AutocompleteArrayInput label="Publishers" optionText="name" optionValue="code" fullWidth />
          </ReferenceArrayInput>

          <TextInput source="segment.filter_publisher.match_type" label="Match Type" choices={matchTypeChoices} initialValue="exact" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
};

export function SiteFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Sites" values={segmentValues(record, 'filter_site')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_site.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <ReferenceArrayInput source="segment.filter_site.values" label="Sites"
            filter={props.filter ? props.filter : null}
            reference="sites"
            basePath='sites'
            perPage={20}
            sort={{ field: 'name', order: 'ASC' }}
            filterToQuery={searchText => ({ search_name: searchText })}
            emptyText="- None -">
            <AutocompleteArrayInput label="Sites" optionText={e => siteFormat(permissions, e)} optionValue="code" fullWidth/>
          </ReferenceArrayInput>

          <TextInput source="segment.filter_site.match_type" label="Match Type" choices={matchTypeChoices} initialValue="exact" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function PlacementFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Placements" values={segmentValues(record, 'filter_placement')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_placement.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <ReferenceArrayInput source="segment.filter_placement.values" label="Sites"
            filter={props.filter ? props.filter : null}
            reference="placements"
            basePath='placements'
            perPage={20}
            sort={{ field: 'name', order: 'ASC' }}
            filterToQuery={searchText => ({ search_name: searchText })}
            emptyText="- None -">
            <AutocompleteArrayInput label="Placements" optionText={e => siteFormat(permissions, e)} optionValue="code" fullWidth/>
          </ReferenceArrayInput>

          <TextInput source="segment.filter_placement.match_type" label="Match Type" choices={matchTypeChoices} initialValue="exact" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function TopLevelDomainFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
      <FilterCardTitle title="Top Level Domains" values={segmentValues(record, 'filter_top_level_domain')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_top_level_domain.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <TextInput multiline label="Values"
            source="segment.filter_top_level_domain.values"
            helperText="Format: domain1.com<NEW LINE>domain2.com"
            validate={validateListSize}
            fullWidth
          />
          <TextInput source="segment.filter_top_level_domain.match_type" label="Match Type" choices={matchTypeChoices} initialValue="equalsIgnoreCase" disabled style={{ visibility: 'hidden', display: 'none' }} />
        {/* <br/>
        <SelectInput source="segment.filter_top_level_domain.dynamic_parameter" label="Dynamic filter"
          choices={[{ id: 'NONE', name: '- None -' }, { id: 'fill_rate', name: 'Fill rate <=' }, { id: 'response_rate', name: 'Response rate <=' }]}
          initialValue="NONE"
          style={{ marginRight: '5px' }} />
        <NumberInput label='value' source='segment.filter_top_level_domain.dynamic_parameter_value'
          min={0} step={0.01} validate={validFrequencyCap} style={{ marginRight: '5px' }} />
        <NumberInput source="segment.filter_top_level_domain.dynamic_offset" label="Day Offset"
          min={1} step={1} max={7} validate={validateDays} initialValue="1"
          style={{ marginRight: '5px' }} style={{ marginRight: '5px' }} /> */}
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function IABCategoriesFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Declared IAB Categories" values={segmentValues(record, 'filter_iab_categories_declared')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_iab_categories_declared.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <ReferenceArrayInput source="segment.filter_iab_categories_declared.values" label="Categories"
              reference="iab_categories"
              basePath='iab_categories'
              perPage={120}
              sort={{ field: 'name', order: 'DESC' }}
              filterToQuery={searchText => ({ search_name: searchText })}>
              <AutocompleteArrayInput label="Declared IAB Categories" optionText='name' fullWidth/>
          </ReferenceArrayInput>
          <TextInput source="segment.filter_iab_categories_declared.match_type" label="Match Type" choices={matchTypeChoices} 
          initialValue="equalsIgnoreCase" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function IABCategoriesPredictedFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Predicted IAB Categories" values={segmentValues(record, 'filter_iab_categories_predicted')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_iab_categories_predicted.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <ReferenceArrayInput source="segment.filter_iab_categories_predicted.values"
              reference="iab_categories"
              basePath='iab_categories'
              perPage={120}
              sort={{ field: 'name', order: 'DESC' }}
              filterToQuery={searchText => ({ search_name: searchText })}>
              <AutocompleteArrayInput label="Predicted IAB Categories" optionText='name' fullWidth />
          </ReferenceArrayInput>
          <TextInput source="segment.filter_iab_categories_predicted.match_type" label="Match Type" choices={matchTypeChoices} 
            initialValue="equalsIgnoreCase" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function PageUrlFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Page URLs" values={segmentValues(record, 'filter_page_url')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_page_url.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <SelectInput source="segment.filter_page_url.match_type" label="Match Type" choices={matchTypeChoices} initialValue="contains" />
          <TextInput multiline label="Values"
            source="segment.filter_page_url.values"
            helperText="Format: Page URL 1\nPage URL 2"
            fullWidth />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function CountryFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Countries" values={segmentValues(record, 'filter_country')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_country.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <SelectArrayInput label="Countries"
            choices={countryChoices}
            source="segment.filter_country.values"
            fullWidth />
          <TextInput source="segment.filter_country.match_type" label="Match Type" choices={matchTypeChoices} initialValue="equalsIgnoreCase" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function StateFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="States" values={segmentValues(record, 'filter_state')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_state.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <ArrayInput source="segment.filter_state.values" >
            <SimpleFormIterator>
              <TextInput fullWidth />
            </SimpleFormIterator>
          </ArrayInput>
          <TextInput source="segment.filter_state.match_type" label="Match Type" initialValue="equalsIgnoreCase" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function DeviceTypeFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Devices" values={segmentValues(record, 'filter_device_type')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
        <BooleanInput source="segment.filter_device_type.exclude" label="Exclude" initialValue={false} 
        onChange={handleClickExclude} 
        style={ showExcludeInput(permissions, props)}/>
        <SelectArrayInput label="Devices" choices={deviceTypeChoices}
          source="segment.filter_device_type.values"
          fullWidth
        />
        <TextInput source="segment.filter_device_type.match_type" label="Match Type" choices={matchTypeChoices} initialValue="equalsIgnoreCase" disabled style={{ visibility: 'hidden', display: 'none' }} />

        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function AdSizeFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Ad Sizes" values={segmentValues(record, 'filter_adsize')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_adsize.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <TextInput multiline label="Ad Sizes"
            source="segment.filter_adsize.values"
            helperText="Format: 300x250\n728x90"
            fullWidth
          />
          <TextInput source="segment.filter_adsize.match_type" label="Match Type" choices={matchTypeChoices} initialValue="exact" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function DivIDFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Div IDs" values={segmentValues(record, 'filter_divid')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_divid.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <SelectInput source="segment.filter_divid.match_type" label="Match Type" choices={matchTypeChoices} initialValue="equalsIgnoreCase" />
          <TextInput multiline label="Div IDs"
            source="segment.filter_divid.values"
            helperText="Format: DIV1\nDIV2"
            fullWidth
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function ViewabilityFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Viewability" values={segmentValues(record, 'filter_viewability')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <TextInput source="segment.filter_viewability.match_type" label="Match Type" choices={matchTypeChoices} initialValue="exact" disabled style={{ visibility: 'hidden', display: 'none' }} />
          <BooleanInput source="segment.filter_viewability.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <SelectArrayInput label="Viewability"
            choices={viewabilityChoices}
            source="segment.filter_viewability.values"
            fullWidth
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function BidderFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Bidders" values={segmentValues(record, 'filter_bidder')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_bidder.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>

          <ReferenceArrayInput label="Bidders"
            perPage={15}
            sort={{ field: 'name', order: 'ASC' }}
            filter={{ hidden: false }}
            filterToQuery={searchText => ({ search_name: searchText })}
            source="segment.filter_bidder.values"
            reference="bidders"
            basePath='bidders'>
            <AutocompleteArrayInput optionText={record => (record && record.name) ? `${record.name} (${record.code})` : ""} optionValue="code" fullWidth/>
          </ReferenceArrayInput>

          <TextInput source="segment.filter_bidder.match_type" label="Match Type" choices={matchTypeChoices} initialValue="exact" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function ImpressionTypeFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Impression Types" values={segmentValues(record, 'filter_impression_type')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_impression_type.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <SelectArrayInput label="Impression Type" choices={[
              { id: 'BANNER', name: 'Banner' },
              { id: 'VIDEO', name: 'Video' },
              { id: 'AUDIO', name: 'Audio' },
              { id: 'NATIVE', name: 'Native' },
            ]}
            source="segment.filter_impression_type.values"
            defaultValue={props.defaultValues}
            fullWidth
          />
          <TextInput source="segment.filter_impression_type.match_type" label="Match Type" choices={matchTypeChoices} initialValue="equalsIgnoreCase" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function ChannelFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Channels" values={segmentValues(record, 'filter_channel')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_channel.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <SelectArrayInput label="Channel" 
            choices={[
                { id: 'web', name: 'WEB' },
                { id: 'amp', name: 'Google AMP' },
                { id: 'app', name: 'APP' }
              ]}
            source="segment.filter_channel.values"
            defaultValue={props.defaultValues}
            fullWidth
          />
          <TextInput source="segment.filter_channel.match_type" label="Match Type" choices={matchTypeChoices} initialValue="equalsIgnoreCase" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function HttpHeaderFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="HTTP Headers" values={segmentValues(record, 'filter_header')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_header.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <ArrayInput source="segment.filter_header.values">
            <SimpleFormIterator>
              <TextInput fullWidth/>
            </SimpleFormIterator>
          </ArrayInput>
          <TextInput source="segment.filter_header.match_type" label="Match Type" choices={matchTypeChoices} initialValue="equalsIgnoreCase" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function CookiesFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Cookies" values={segmentValues(record, 'filter_cookie')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_cookie.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <ArrayInput source="segment.filter_cookie.values">
            <SimpleFormIterator>
              <TextInput fullWidth/>
            </SimpleFormIterator>
          </ArrayInput>
          <TextInput source="segment.filter_cookie.match_type" label="Match Type" initialValue="equalsIgnoreCase" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function MediaCategoriesFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Media Categories" values={segmentValues(record, 'filter_media_cetegories')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_media_cetegories.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <SelectArrayInput label="Media Categories" choices={mediaCategories}
            source="segment.filter_media_cetegories.values"
            fullWidth
          />
          <TextInput source="segment.filter_media_cetegories.match_type" label="Match Type" choices={matchTypeChoices} initialValue="equalsIgnoreCase" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function IpAddressFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="IP Address" values={segmentValues(record, 'filter_ip')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_ip.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <TextInput multiline label="IP Addresses"
            source="segment.filter_ip.values"
            helperText= "Format: 192.168.1.15 <NEW LINE> 1.0.0.10"
            validate={validateListSize}
            fullWidth
          />
          <TextInput source="segment.filter_ip.match_type" label="Match Type" choices={matchTypeChoices} initialValue="equalsIgnoreCase" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function OSFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Operating Systems" values={segmentValues(record, 'filter_os')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_os.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <SelectArrayInput label="Operating Systems" choices={osChoices}
            source="segment.filter_os.values"
            fullWidth
          />
          <TextInput source="segment.filter_os.match_type" label="Match Type" choices={matchTypeChoices} initialValue="equalsIgnoreCase" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function SegmentFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Segments" values={segmentValues(record, 'filter_segment')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_segment.exclude" label="Exclude" initialValue={false} onChange={handleClickExclude} style={{display: 'none'}} />
          <ReferenceArrayInput source="segment.filter_segment.values" label="Segments"
            reference="segments"
            basePath='segments'
            perPage={20}
            sort={{ field: 'name', order: 'ASC' }}
            filterToQuery={searchText => ({ search_name: searchText })}
            allowEmpty emptyText="- None -">
            <AutocompleteArrayInput label="Segments" optionText="name" optionValue="code" fullWidth />
          </ReferenceArrayInput>
          <TextInput source="segment.filter_segment.match_type" label="Match Type" choices={matchTypeChoices} initialValue="exact" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function AdvertiserFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="Advertiser" values={segmentValues(record, 'filter_advertiser')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_segment.exclude" label="Exclude" initialValue={false} onChange={handleClickExclude} style={{display: 'none'}} />
          <ReferenceArrayInput source="segment.filter_advertiser.values" label="Advertisers"
            reference="advertisers"
            basePath='advertisers'
            perPage={20}
            sort={{ field: 'name', order: 'ASC' }}
            filterToQuery={searchText => ({ search_name: searchText })}
            allowEmpty emptyText="- None -">
            <AutocompleteArrayInput label="Segments" optionText="name" optionValue="code" fullWidth />
          </ReferenceArrayInput>
          <TextInput source="segment.filter_advertiser.match_type" label="Match Type" choices={matchTypeChoices} initialValue="exact" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function UserAgentFilter ({record, permissions, ...props}) {
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title="User-Agents" values={segmentValues(record, 'filter_useragent')} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source="segment.filter_useragent.exclude" label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <TextInput multiline label="User-Agents (Lower case)"
            source="segment.filter_useragent.values"
            helperText= "Format (Lower case): User-Agent <NEW LINE> User-Agent"
            validate={validateListSize}
            fullWidth
          />
          <TextInput source="segment.filter_useragent.match_type" label="Match Type" initialValue="contains" disabled style={{ visibility: 'hidden', display: 'none' }} />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}

export function MultipleChoiceFilter ({record, permissions, ...props}) {
  const title = props.title;
  const filterName = props.filterName;
  const choices = props.choices;
  const matchType = props.matchType || 'equalsIgnoreCase';
  const matchTypeStyle = props.matchTypeHidden ? { visibility: 'hidden', display: 'none' } : {};
  const classes = useStyles(props);
  return (
    <Accordion className={classes.filter}>
      <AccordionSummary expandIcon={<ExpandMore />}>
        <FilterCardTitle title={title} values={segmentValues(record, filterName)} />
      </AccordionSummary>
      <AccordionDetails>
        <Box  style={{ width: '100%' }}>
          <BooleanInput source={`segment.${filterName}.exclude`} label="Exclude" initialValue={false} 
          onChange={handleClickExclude} 
          style={ showExcludeInput(permissions, props)}/>
          <SelectInput source={`segment.${filterName}.match_type`} label="Match Type" choices={matchTypeChoices} initialValue={matchType} style={matchTypeStyle} />
          <SelectArrayInput label={title} choices={choices}
            source={`segment.${filterName}.values`}
            fullWidth
          />
        </Box>
      </AccordionDetails>
    </Accordion>
  )
}